import React ,{useState,useEffect, useRef} from 'react';
import styled from 'styled-components';
import appInfoContainer from '../../auth/appInfoContainer';
import { useSelector } from 'react-redux';


export default function CommentBarChat({scrollToBottom,chatSubmit,chatCont,setChatCont, setAreaBottomPadding}) {
    const userInfo = useSelector(state=>{ return state.userInfo}); 
    const chatInput = useRef(null);

    const [rows,setRows]= useState(1);
    const [minRows,setMinRows]= useState(1);
    const [maxRows,setMaxRows]= useState(5);

    const handleChange = (event) => {
		const textareaLineHeight = 24;
		
		const previousRows = event.target.rows;
  	    event.target.rows = minRows; // reset number of rows in textarea 
		
		const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);
    
    if (currentRows === previousRows) {
    	event.target.rows = currentRows;
    }
		
		if (currentRows >= maxRows) {
			event.target.rows = maxRows;
			event.target.scrollTop = event.target.scrollHeight;
		}
    
        setChatCont(event.target.value);
        setRows(currentRows < maxRows ? currentRows : maxRows);

	};

    const onSubmit = async () =>{
        setRows(1);
        await chatSubmit();
        setUpdatedBottomPadding();
    }

    const onFocus = () =>{
        setTimeout(function(){scrollToBottom();},100);
    }
    useEffect(() => {
         setUpdatedBottomPadding();
    },[]);
    const handleOnKeyUp = () =>{
        setUpdatedBottomPadding()
    }
    const setUpdatedBottomPadding =() =>{
        let updatedHeight = chatInput.current.clientHeight;
        setAreaBottomPadding(updatedHeight);
    }
      
    return (
        <MainfixbarInner ref={chatInput}>
            <User>
                <Images src={appInfoContainer.imagePath +"/user_profile_img/"+userInfo.profile_img}/>
            </User>
            <Textbox>
                <Txtlist>
                    <Textbox_input  
                        onFocus={onFocus}
                        rows={rows}
                        value={chatCont}
                        className={'textarea'}
                        onChange={handleChange}
                        onKeyUp={handleOnKeyUp}
                        type="text" placeholder="자유롭게 이야기를 나눠보세요 :) " 
                    />
                </Txtlist>
                <Textbox_submit type="submit" value="작성" onClick={onSubmit}/>
            </Textbox>
        </MainfixbarInner>
    )
}

const Images = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const MainfixbarInner = styled.div`
    position: fixed;
    left:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: calc(100vw*(69/375));
    height:auto;
    background-color: #ffefce;
    padding : calc(100vw*(15/375)) calc(100vw*(17/375)) calc(100vw*(14/375)) calc(100vw*(16/375));
`
const User = styled.p`
    width: calc(100vw*(40/375));
    height: calc(100vw*(40/375));
    border-radius: 50%;
    overflow:hidden;
    border: solid calc(100vw*(1/375)) #c6c6c6;
`
const Textbox = styled.div`
    width: calc(100vw*(295/375));
    min-height: calc(100vw*(40/375));
    height:auto;
    border-radius: calc(100vw*(22/375));
    border: solid calc(100vw*(1/375)) #888888;
    margin-left: calc(100vw*(7/375));
    padding : 0 calc(100vw*(17/375)) 0 calc(100vw*(19/375));
    display: flex;
    align-items: center;
    justify-content: space-between;
`
const Txtlist = styled.div`
    display: flex;
    align-items: center;
    width: 90%;
    height:100%;
`
const Textbox_input = styled.textarea`
    background: none;
    width: 87%;
    font-size: calc(100vw*(14/375));
    color: #1d1d1d;
    line-height: calc(100vw*(24/375));
    white-space: pre-wrap;
`
const Textbox_submit = styled.input`
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    color: #ff8900;
    background: none;
`
const Nickname = styled.a`
    font-weight: 500;
    font-size:  calc(100vw*(14/375));
    color: #ff8900;
    width: auto;
    max-width: calc(100vw*(66/375));
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap
`